module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/user-97c0e70cd623f8d7099f9b95314f1a2d.svg";